import { omit } from 'lodash';

import { replaceNullToString, transformIncluded } from 'modules/common/utils';

export const PARNER_URL = process.env.REACT_APP_SM_WEBSITE_DOMAIN;

export const transformPartner = (item, included = []) => {
  const $x = transformIncluded(item, included);
  const partner_settings = $x?.included?.partner_settings || [];

  const $partner_settings = partner_settings
    ? partner_settings?.map((x) => ({
        ...omit(x, ['attributes', 'links']),
        ...x?.attributes,
      }))
    : [];

  const payment_channels = $partner_settings?.find(
    (x) => x?.key === 'payment-channels'
  );

  const x = {
    ...omit(item, ['attributes', 'links', 'relationships']),
    ...item?.attributes,
    parner_link: `${PARNER_URL}/?partner=${$x?.attributes?.code}`,
    merchant_count: 0,
    payment_channels,
    mobile_number: item?.attributes?.user?.mobile_number,
    email: item?.attributes?.user?.email,
    changed_password_at: item?.attributes?.user?.changed_password_at,
    is_mfa_enabled: item?.attributes?.user?.is_mfa_enabled,
    default_mfa: item?.attributes?.user?.default_mfa,
  };

  return replaceNullToString(x);
};
